<template>
  <pull-to class="eds-flow-info-root" :style="{ height: height }" :top-load-method="refresh"
    :top-config="TOP_DEFAULT_CONFIG" :bottom-config="BOTTOM_DEFAULT_CONFIG">
    <div style="text-align: center; color: red" v-if="handleFlag">
      {{ handleTitle }}
    </div>
    <v-divider></v-divider>
    <div class="flow_content_main" v-if="flowInfo">
      <template v-if="isEn">
        <img v-if="flowInfo.state == 'approved' || flowInfo.state == 'processing' || flowInfo.state == 'processed'"
          style="float: right; z-index: 1999" src="imgs/svg/eds/icon_approved_en.svg" />
        <img v-else-if="flowInfo.state == 'rejected'" style="float: right; z-index: 1999"
          src="imgs/svg/eds/icon_rejected_en.svg" />
      </template>
      <template v-else>
        <img v-if="flowInfo.state == 'approved' || flowInfo.state == 'processing' || flowInfo.state == 'processed'"
          style="float: right; z-index: 1999" src="imgs/svg/eds/icon_approved.svg" />
        <img v-else-if="flowInfo.state == 'rejected'" style="float: right; z-index: 1999"
          src="imgs/svg/eds/icon_rejected.svg" />
      </template>
      <div class="eds_content2">
        <span class="eds_content_prop">{{ $t('发起人') }} </span>
        <span class="eds_content_value">{{ flowInfo.userDisplayName }}</span>
        <span class="eds_content_value" v-if="isDev">({{ flowInfo.id + $t('测试') }})</span>
      </div>
      <div class="eds_content2">
        <span class="eds_content_prop">{{ $t('所在部门') }}</span>
        <span class="eds_content_value">{{ flowInfo.orgDisplayName }}</span>
      </div>
      <div class="eds_content2">
        <span class="eds_content_prop">{{ $t('申请标题') }}</span>
        <span class="eds_content_value">{{ flowInfo.title }}</span>
      </div>
      <div class="eds_content2">
        <span class="eds_content_prop">{{ $t('申请描述') }}</span>
        <span class="eds_content_value">{{ flowInfo.remark }}</span>
      </div>
      <div class="eds_content2">
        <span class="eds_content_prop">{{ $t('文件') }}</span>
        <span class="eds_content_value flow_file_value">
          <eDSCompFlowFile :flowInfo="flowInfo" :flowFiles="flowFiles" :allowDownload="allowDownload" :flowTid="flowTid"
            :flowTname="flowTname" />
        </span>
      </div>
    </div>
    <v-stepper class="flow_step" v-if="flowInfo" :value="step" vertical>
      <v-stepper-step :complete="true" step="0">
        {{ $t('提交') }}
        <small>{{ flowInfo.userDisplayName + ' ' + $t('提交申请') }}</small>
        <div class="flow-step__time">
          {{ convertDate(flowInfo.createdAt) }}
        </div>
      </v-stepper-step>
      <v-stepper-content step="0"></v-stepper-content>
      <template v-for="(task, index) in mergeTasks">
        <template v-if="task.state != ''">
          <template v-if="task.state == 'awaiting'">
            <v-stepper-step :key="index" :complete="false" step='···'>
              {{ getTaskTitle(task) }}
              <small>
                {{ getTaskDescription(task) }}
              </small>
              <div v-if="task.processedAt" class="flow-step__time">
                {{ convertDate(task.processedAt) }}
              </div>
            </v-stepper-step>
          </template>
          <template v-else>
            <v-stepper-step :key="index" :complete="true" :step="task.id ? task.id : 0">
              {{ getTaskTitle(task) }}
              <small>
                {{ getTaskDescription(task) }}
              </small>
              <div v-if="task.processedAt" class="flow-step__time">
                {{ convertDate(task.processedAt) }}
              </div>
            </v-stepper-step>
          </template>
          <!--产生连线效果 -->
          <v-stepper-content :key="'content' + index" :step="task.id ? task.id : 0"></v-stepper-content>
        </template>
      </template>
    </v-stepper>
    <v-dialog persistent v-if="openFileLoading" :value="openFileLoading" @input="openFileLoading" max-width="80px"
      max-height="80px">
      <v-progress-circular class="eds_progress_openfile_loading" v-if="openFileLoading" :size="50" color="blue"
        indeterminate></v-progress-circular>
    </v-dialog>
  </pull-to>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import PullTo from 'vue-pull-to'
import APP_CONFIG from '../../config/App'
import devHelper from '../../util/devHelper'
import dateHelper from '../../util/date'
import msgbus from '../../msgBus'
import functions from '../../functions'
import {
  WORKFLOW_NODE_TYPE,
  TASK_TYPE16,
  WORKFLOW_TAST_State16,
} from '@/config/work'
import eDSCompMyTaskList from '../../components/eDSCompMyTaskList'
import eDSCompMyApplicationList from '../../components/eDSCompMyApplicationList'
import eDSCompFlowFile from '../../components/eDSCompFlowFile'
import { styleNo } from '../../config/BottomBtn'


export default {
  name: 'eDSFlowInfo16',
  components: {
    PullTo,
    eDSCompMyTaskList,
    eDSCompMyApplicationList,
    eDSCompFlowFile,
  },
  data() {
    return {
      TOP_DEFAULT_CONFIG: APP_CONFIG.tTOP_DEFAULT_CONFIG(),
      BOTTOM_DEFAULT_CONFIG: APP_CONFIG.tBOTTOM_DEFAULT_CONFIG(),
      title: this.$t('流程'),
      handleFlag: false,
      handleTitle: this.$t('等待我审批'),
      step: 2, // 当前步骤
      TASK_Type: TASK_TYPE16,
      bottomButtons: [],
      flowID: '', // 流程编号
      flowTid: '', // 当前流程所属租户tid
      flowTname: '', // 当前流程所属租户tname
      userID: '', // 登录账户在当前租户的用户ID
      flowInfo: null, // 流程信息
      flowFiles: [], // 流程文件列表
      mergeTasks: [], // 流程过程列表
      taskInfo: null,
      allowDownload: false, // 是否允许下载
    }
  },
  computed: {
    isDev() {
      return devHelper.isDevMode() // 判断是否开启了测试模式
    },
    height() {
      if (this.bottomButtons) {
        return `calc(${window.innerHeight}px - 48px - 36px ` + ')'
      } else {
        return `calc(${window.innerHeight}px - 48px ` + ')'
      }
    },
    openFileLoading() {
      return msgbus.vm.getIsDownloading()
    },
    isZh() {
      return this.$i18n.locale == 'zh'
    },
    isEn() {
      return this.$i18n.locale == 'en'
    }
  },
  methods: {
    goBack() {
      // setBackDisabled会清空特殊路由信息，因此调用之前先读取是否特殊路由信息
      const backSpecialRoute = msgbus.vm.getBackSpecialRoute()
      msgbus.vm.setBackDisabled(true)

      // 若有特殊路由设置信息，则调转到指定页面
      if (backSpecialRoute) {
        this.$router.replace({ name: backSpecialRoute })
      } else {
        this.$router.back()
      }
    },

    getTaskTitle(task) {
      let title = this.$t(TASK_TYPE16[task.nodeType].name)
      // 如果是用户文件处理任务，则进一步明确任务标题
      if (task.nodeType == WORKFLOW_NODE_TYPE.FileProc) {
        let sendMail = this.judgeWorkflowTaskSendEmail(task)
        if (sendMail) {
          title = this.$t('发送邮件')
        } else {
          title = this.$t('下载文件')
        }
      }
      return title
    },

    getTaskDescription(task) {
      let temp = ''
      switch (task.nodeType) {
        case WORKFLOW_NODE_TYPE.Initiate:
          temp = task.userDisplayName + ' ' + this.$t('提交申请')
          break
        case WORKFLOW_NODE_TYPE.Approve:
        case WORKFLOW_NODE_TYPE.AddApprove:
          switch (task.state) {
            case WORKFLOW_TAST_State16.Awaiting:
              temp = this.$t('等待') + ' ' + task.userDisplayName + ' ' + this.$t('审批')
              break
            case WORKFLOW_TAST_State16.Approved:
              temp = task.userDisplayName + ' ' + this.$t('已同意') + ' ' + task.remark
              break
            case WORKFLOW_TAST_State16.FinishApproved:
              temp = task.userDisplayName + ' ' + this.$t('已直接通过') + ' ' + task.remark
              break
            case WORKFLOW_TAST_State16.Rejected:
              temp = task.userDisplayName + ' ' + this.$t('已拒绝') + ' ' + this.$t('拒绝原因') + ' ' + task.remark + (task.error != '' ? this.$t(task.error) : '')
              break
            case WORKFLOW_TAST_State16.Terminated:
              temp = task.userDisplayName + ' ' + this.$t('已终止') + ' ' + (task.error != '' ? this.$t(task.error) : '')
              break
          }
          break
        case WORKFLOW_NODE_TYPE.CC:
          switch (task.state) {
            case WORKFLOW_TAST_State16.Awaiting:
              temp = this.$t('等待') + ' ' + task.userDisplayName + ' ' + this.$t('审阅')
              break
            case WORKFLOW_TAST_State16.Reviewed:
              temp = task.userDisplayName + ' ' + this.$t('已审阅')
              break
            case WORKFLOW_TAST_State16.Terminated:
              temp = task.userDisplayName + ' ' + this.$t('已终止') + ' ' + (task.error != '' ? this.$t(task.error) : '')
              break
          }
          break
        case WORKFLOW_NODE_TYPE.RobotFileProc:
          switch (task.state) {
            case WORKFLOW_TAST_State16.Awaiting:
              temp = this.$t('等待') + this.$t('文件处理')
              break
            case WORKFLOW_TAST_State16.Processed:
              temp = this.$t('文件已处理')
              break
            case WORKFLOW_TAST_State16.Terminated:
              temp = this.$t('文件处理') + this.$t('已终止') + ' ' + (task.error != '' ? this.$t(task.error) : '')
              break
          }
          break
        case WORKFLOW_NODE_TYPE.FileProc:
          var sendMail = this.judgeWorkflowTaskSendEmail(task)
          switch (task.state) {
            case WORKFLOW_TAST_State16.Awaiting:
              var info = sendMail ? this.$t('发送邮件') : this.$t('下载')
              temp = this.$t('等待') + ' ' + task.userDisplayName + ' ' + info + ' ' + (task.error != '' ? this.$t(task.error) : '')
              break
            case WORKFLOW_TAST_State16.Processed:
              info = sendMail ? this.$t('邮件已发送') : this.$t('已下载')
              temp = task.userDisplayName + ' ' + info
              break
            case WORKFLOW_TAST_State16.Terminated:
              temp = task.userDisplayName + ' ' + this.$t('已终止') + ' ' + (task.error != '' ? this.$t(task.error) : '')
              break
          }
          break
      }
      return temp
    },

    // 判断流程任务是否发送邮件
    judgeWorkflowTaskSendEmail(task) {
      if (task.node && task.node.type == WORKFLOW_NODE_TYPE.FileProc && task.node.options) {
        let sendMail = task.node.options.sendMail ? task.node.options.sendMail : false
        let autoSendMail = task.node.options.autoSendMail ? task.node.options.autoSendMail : false
        if (sendMail || autoSendMail)
          return true
      }
      return false
    },

    // 拒绝
    onRefuse() {
      this.taskInfo.workflowTitle = this.flowInfo.title
      this.$router.push({
        name: 'taskrefuse',
        params: { taskInfo: this.taskInfo, taskTid: this.flowTid },
      })
    },
    //同意
    onAgree() {
      this.taskInfo.workflowTitle = this.flowInfo.title
      this.$router.push({
        name: 'taskagree',
        params: { taskInfo: this.taskInfo, taskTid: this.flowTid },
      })
    },
    //直接完成
    onFinish() {
      this.$router.push({
        name: 'flowfinish',
        params: { flowInfo: this.flowInfo, flowTid: this.flowTid },
      })
    },
    // 转化时间
    convertDate(time) {
      let timeUnit = dateHelper.string2Timestamp(time)
      return dateHelper.timestamp2LocalTime(timeUnit).substr(5)
    },
    // 刷新界面
    refresh(loaded) {
      // 根据流程编号，查询流程信息
      msgbus.vm.fetchFlowInfo({
        authorization: {
          Authorization: 'Bearer ' + msgbus.vm.getAccountToken(),
        },
        tid: this.flowTid,
        flowID: this.flowID,
        vm: msgbus.vm,
      })
        .then(
          () => {
            this.flowInfo = msgbus.vm.getFlowInfo()
            if (loaded != null) {
              loaded('done')
            }
            // 界面显示处理
            this.showFlowInfo()
            // 切换界面样式
            this.changeView()
          },
          () => {
            if (loaded != null) {
              loaded('fail')
            }
          }
        )
    },
    // 切换界面样式
    changeView() {
      msgbus.vm.setTitle(this.title)
      msgbus.vm.setTitleVisible(true)
      msgbus.vm.setBackDisabled(false)
      msgbus.vm.setBackIcon('arrow_back')
      msgbus.vm.setMsgInputVisible(false)
      msgbus.vm.setBottomNavVisible(false)
      if (this.bottomButtons.length > 0) {
        msgbus.vm.setBottomBtnVisible(true)
        msgbus.vm.setBottomBtn({ value: this.bottomButtons })
        msgbus.vm.setContentHeight({
          value: `calc(${window.innerHeight}px - 48px - 36px ` + ')',
        })
      } else {
        msgbus.vm.setBottomBtnVisible(false)
        msgbus.vm.setContentHeight({
          value: `calc(${window.innerHeight}px - 48px ` + ')',
        })
      }
    },
    // 显示流程信息
    showFlowInfo() {
      // 获取流程标题
      this.title = this.flowInfo.title

      // 根据流程编号，查询流程文件信息
      msgbus.vm.fetchFlowFiles({
        authorization: {
          Authorization: 'Bearer ' + msgbus.vm.getAccountToken(),
        },
        tid: this.flowTid,
        flowID: this.flowID,
        vm: msgbus.vm,
      }).then(
        () => {
          this.flowFiles = msgbus.vm.getFlowFiles()
        },
        () => { }
      )

      // 1、判断是否有文件下载能力：流程中只要有一个任务是当前用户的，且该任务用户允许下载，则可以下载
      if (this.flowInfo.tasks) {
        var taskTemp = this.flowInfo.tasks.filter(
          (task) => task.userID == this.userID && task.allowDownload
        )
        if (taskTemp && taskTemp.length > 0) {
          this.allowDownload = true
        }

        // 2、判断流程当前任务是否是当前登录用户，若是，则进行操作命令识别
        taskTemp = this.flowInfo.tasks.filter(
          (task) => task.state == 'awaiting' && task.userID == this.userID
        )
        if (taskTemp && taskTemp.length > 0) {
          this.taskInfo = taskTemp[0]

          this.handleFlag = true

          switch (this.taskInfo.nodeType) {
            case 'approve':
              this.handleTitle = this.$t('等待我审批')
              this.bottomButtons = this.taskInfo.allowFinish
                ? [
                  {
                    primary: false,
                    title: this.$t('拒绝'),
                    // style: styleNo[3],
                    style: styleNo[2],
                    func: this.onRefuse,
                    params: '',
                  },
                  // {
                  //   primary: false,
                  //   title: '直接完成',
                  //   style: styleNo[3],
                  //   func: this.onFinish,
                  //   params: '',
                  // },
                  {
                    primary: true,
                    title: this.$t('同意'),
                    // style: styleNo[3],
                    style: styleNo[2],
                    func: this.onAgree,
                    params: '',
                  },
                ]
                : [
                  {
                    primary: false,
                    title: this.$t('拒绝'),
                    style: styleNo[2],
                    func: this.onRefuse,
                    params: '',
                  },
                  {
                    primary: true,
                    title: this.$t('同意'),
                    style: styleNo[2],
                    func: this.onAgree,
                    params: '',
                  },
                ]
              break
            case 'file_proc':
              this.handleTitle = this.$t('等待文件处理')
              this.bottomButtons = [
                {
                  primary: false,
                  title: this.$t('请至pc端处理'),
                  style: styleNo[1],
                  func: null,
                  params: '',
                },
              ]
              break
          }
        }

        // 对流程的任务进行显示处理（未审批的同级任务合并显示）
        let tasksTmp = []
        let levelsTmp = []
        let mergeTasksTmp = []
        let mergeTaskTmp = {}

        // 过滤出所有'awaiting'状态的任务
        tasksTmp = this.flowInfo.tasks.filter(
          (task) => task.state == 'awaiting' || task.state == 'new'
        )
        // 获取所有的等级信息
        tasksTmp.forEach((task) => {
          if (levelsTmp.indexOf(task.level) == -1) {
            levelsTmp.push(task.level)
          }
        })
        // 按等级信息，合并任务
        levelsTmp.forEach((level) => {
          let sameLevelTasks = tasksTmp.filter((task) => task.level == level)
          mergeTaskTmp = { ...sameLevelTasks[0] }
          if (sameLevelTasks.length > 1) {
            sameLevelTasks.splice(0, 1)
            sameLevelTasks.forEach((task) => {
              mergeTaskTmp.userDisplayName += ',' + task.userDisplayName
            })
            mergeTaskTmp.isMergeTask = true
          }
          mergeTasksTmp.push(mergeTaskTmp)
        })

        this.mergeTasks = [
          ...this.flowInfo.tasks.filter(
            (t) => !(t.state === 'awaiting' || t.state === 'new')
          ),
          ...mergeTasksTmp,
        ]
        this.step =
          this.mergeTasks.filter(
            (t) => t.state == 'approved' || t.state == 'rejected'
          ).length + 1
      }
    },
  },
  created() {
    console.log('调试代码')
    if (msgbus.vm.getAccountToken() == null) {
      window.location.href = '/'
      return
    }
    // 初始置正在下载标记false
    msgbus.vm.setIsDownloading({ value: false })

    // 如果有路由参数，则读取路由参数：当前流程编号\流程对应的租户tid，否则从store中读取当前流程信息
    if (this.$route.params.flowID && this.$route.params.flowID != '') {
      this.flowID = this.$route.params.flowID
      this.flowTid = this.$route.params.flowTid
      // 保存当前流程信息
      msgbus.vm.setCurrentFlow({
        value: {
          flowID: this.flowID,
          flowTid: this.flowTid,
        },
      })
    } else {
      let currentFlow = msgbus.vm.getCurrentFlow()
      this.flowID = currentFlow.flowID
      this.flowTid = currentFlow.flowTid
    }
    this.flowTname = functions.login.funcGetTnameBaseTid(this.flowTid)
    this.userID = functions.login.funcGetUserOIDBaseTid(this.flowTid)

    // 刷新界面
    this.refresh((result) => {
      if (result === 'fail') {
        setTimeout(() => {
          this.goBack()
        }, 2000)
      }
    })
  },
  mounted() { },
  beforeDestroy() {
    msgbus.vm.setMenuDisabled(true)
    msgbus.vm.setMenuItems([])
    msgbus.vm.setMenuIcon('')
  },
}
</script>

<style lang="scss">
.eds-flow-info-root {
  background-color: #ffffff;

  .flow_content_main {
    padding: 10px;

    .flow_file_value {
      overflow: hidden;
    }
  }

  .flow_step {
    clear: left;
    box-shadow: 0 -1px 3px -3px rgba(0, 0, 0, 0.2);

    & .v-stepper__step {
      .v-stepper__label {
        color: #383838;
        font-size: 14px;

        &>small {
          color: #8a8a8f;
          font-size: 14px;
        }

        & .flow-step__time {
          font-size: 12px;
          color: #c4c4c4;
          position: absolute;
          right: 10px;
        }
      }
    }
  }
}
</style>
